<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" width="60%" v-model="isOpenDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          CẬP NHẬT ẢNH HỌC SINH THEO FILE ZIP <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5 border">
          <div class="wrap">
            <div v-if="taskProgress.status === 'running'" style=" min-height: 380px" class="pt-14">
              <LoadingUpdateAvatar class="mt-14"></LoadingUpdateAvatar>
            </div>
            <div v-else class="d-flex flex-column justify-center align-center mx-auto" style=" min-height: 380px">
              <div class="upload-zip mt-4 px-8">
                <v-img contain src="@/assets/file-zip.svg"></v-img>
              </div>
              <div class="text-center content-text">
                <p class="mb-2">
                  Đặt chung các file ảnh học sinh cần cập nhật trong cùng 1 folder và nén folder đó để tải lên(.zip)
                </p>
                <p class="mb-2 font-weight-bold">Lưu ý:</p>
                <p class="mb-2 ">Định dạng ảnh: .png hoặc .jpg</p>
                <p class="mb-2 ">
                  Cú pháp đặt tên ảnh: <span class="font-weight-bold">Mã học sinh_Tên học sinh</span> (Ví dụ:
                  01234_Nguyễn Văn A)
                </p>
                <p class="mb-2">Kích thước ảnh khuyên dùng: 360x360px.</p>
                <p class="mb-2">Dung lượng ảnh: thấp hơn 500KB</p>
              </div>
              <div>
                <v-btn @click="onExcelUpload" color="primary" class="elevation-0 white--text mb-14 mt-4">
                  <span class="white--text">Chọn File</span>
                  <input
                    ref="uploader"
                    type="file"
                    class="d-none"
                    accept="application/x-zip-compressed"
                    value="selectedFile"
                    @input="onChange"
                  />
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingUpdateAvatar from './LoadingUpdateAvatar.vue'
export default {
  components: { LoadingUpdateAvatar },
  data() {
    return {
      isOpenDialog: false,
      selectedFile: null,
      isSelecting: false,
      showLoadingLine: false
    }
  },
  computed: {
    ...mapGetters({
      taskProgress: 'taskProgress/taskProgress'
    })
  },
  methods: {
    ...mapActions('taskProgress', ['uploadAvatarStudents']),
    ...mapActions('students', ['fetchStudents']),

    async onChange(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let formData = new FormData()
      formData.append('files', this.selectedFile)
      formData.append('type', 'update-avatar-student')
      formData.append('status', 'running')
      await this.uploadAvatarStudents(formData)

      this.$loading.active = false
      this.selectedFile = null
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    cancel() {
      this.isOpenDialog = false
      this.resetInput()
    },
    openDialog() {
      this.isOpenDialog = true
    },
    resetInput() {
      this.selectedFile = null
      this.isSelecting = false
    }
  },
  watch: {
    async taskProgress() {
      if (this.taskProgress.status === 'finished') {
        if (this.taskProgress.metadata['error'].length > 0) {
          let error = ''
          for (const item of this.taskProgress.metadata['error']) {
            error += `${item}<br/> \n`
          }
          this.$alert.addPeriodError({
            title: 'Lỗi dữ liệu',
            description: error
          })
        } else {
          this.$alert.success('Đã cập nhật ảnh thành công!')
        }
        await this.fetchStudents({
          _start: 0,
          _limit: 5,
          _sort: 'nameToNumber:ASC,index:ASC'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 4px;
}
.upload-zip {
  background: #f5f5f5;
  padding: 30px;
  border-radius: 50%;
}
</style>
